var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.withHours)?[_vm._v(_vm._s(_vm.hours)+":")]:_vm._e(),_vm._v(_vm._s(_vm.minutes)+":"+_vm._s(_vm.seconds))],2)}
var staticRenderFns = []

export { render, staticRenderFns }